import { render, staticRenderFns } from "./addProductDialog.vue?vue&type=template&id=55196802&scoped=true"
import script from "./addProductDialog.vue?vue&type=script&lang=js"
export * from "./addProductDialog.vue?vue&type=script&lang=js"
import style0 from "./addProductDialog.vue?vue&type=style&index=0&id=55196802&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55196802",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55196802')) {
      api.createRecord('55196802', component.options)
    } else {
      api.reload('55196802', component.options)
    }
    module.hot.accept("./addProductDialog.vue?vue&type=template&id=55196802&scoped=true", function () {
      api.rerender('55196802', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/stockPage/addProductDialog/addProductDialog.vue"
export default component.exports